import { render } from "./VACFApprovals.vue?vue&type=template&id=2604f4da"
import script from "./VACFApprovals.vue?vue&type=script&lang=js"
export * from "./VACFApprovals.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__